import React from 'react';
import { Box, Heading, Text, Alert, AlertIcon, AlertTitle, AlertDescription } from '@chakra-ui/react';

const AdminDashboardPage: React.FC = () => {
  return (
    <Box>
      <Heading size="lg" mb={4}>E-shop administrace</Heading>
      <Alert status="info" borderRadius="md" mb={4}>
        <AlertIcon />
        <Box>
          <AlertTitle>Samostatná administrace e-shopu</AlertTitle>
          <AlertDescription fontSize="sm">
            Toto je základní rozhraní pro budoucí správu produktů, objednávek a dopravy.
            V této fázi doporučujeme produkty zakládat přes hlavní MyClub administraci nebo přímo v databázi.
          </AlertDescription>
        </Box>
      </Alert>
      <Text color="gray.600">
        V dalších krocích zde přibudou přehledy objednávek, správa produktů, nastavení Stripe a Packeta integrace
        a nástroje pro zákaznickou podporu (DeepSeek AI chat).
      </Text>
    </Box>
  );
};

export default AdminDashboardPage;
